import { Box } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { changeFileSurveyDate } from "../../../../features/DataRepoSurveyDateSlice";
import { RootState } from "../../../../store/store";

export const DataDescriptionDatePicker = () => {
  const dispatch = useDispatch();
  const selectedDateString = useSelector(
    (state: RootState) => state.fileSurveryDate.value
  );

  const selectedDate = selectedDateString
    ? dayjs(new Date(selectedDateString))
    : null;

  return (
    <Box>
      <DatePicker
        sx={{
          width: "20rem",
          "& .MuiInputLabel-root": {
            color: "#86A2B3",
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: "#86A2B3",
              color: "#86A2B3",
            },
          },
          "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#86A2B3",
            color: "#86A2B3",
          },
        }}
        value={selectedDate}
        onChange={(value) =>
          dispatch(
            changeFileSurveyDate({
              value: value ? value.toISOString() : null,
            })
          )
        }
        label="Data Collection Date (Optional)"
      />
    </Box>
  );
};
